import { useRecoilState } from "recoil";
import { cookieConsentState } from "GlobalStates/CookieConsent";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { ROUTES } from "Features/Routes/routeConstants";
import "./styles.css";

export const CookieBanner = () => {
  const [consent, setConsent] = useRecoilState(cookieConsentState);

  if (consent) return null;

  const handleAccept = () => {
    setConsent(true);
  };

  return (
    <div className="cookie-banner">
      <span className="cookie-text">
        We use cookies to improve your experience on our website.{" "}
        <Link to={ROUTES.PRIVACY_POLICY} className="cookie-link">
          Learn more about our privacy policy.
        </Link>
      </span>
      <Button type="primary" className="cookie-button" onClick={handleAccept}>
        Okay, Got it.
      </Button>
    </div>
  );
};
